import React from "react";
import {
  buildTrafficTakeaway,
  formatVisitCount,
} from "helpers/dashboard/trafficSourcesCopy";

const TrafficSources = ({ trafficSources, days = 30 }) => {
  if (!trafficSources?.channels?.length) {
    return (
      <article className="owner-dashboard__panel owner-dashboard__traffic">
        <h3 className="owner-dashboard__panel-title">How families find your website</h3>
        <p className="owner-dashboard__panel-subtitle">
          We could not load this breakdown right now. Try refreshing the dashboard.
          If it keeps happening, the dashboard server may need a restart.
        </p>
      </article>
    );
  }

  const {
    totalSessions,
    topChannelFriendlyLabel,
    topChannelSharePercent,
    channels,
    topSources,
  } = trafficSources;

  const takeaway = buildTrafficTakeaway(trafficSources);
  const visibleSources = (topSources || []).slice(0, 6);

  return (
    <article className="owner-dashboard__panel owner-dashboard__traffic">
      <div className="owner-dashboard__panel-header owner-dashboard__panel-header--compact">
        <div>
          <h3 className="owner-dashboard__panel-title">How families find your website</h3>
          <p className="owner-dashboard__panel-subtitle">
            Last {days} days · {formatVisitCount(totalSessions)}
            {topChannelFriendlyLabel
              ? ` · Most from ${topChannelFriendlyLabel.toLowerCase()} (${topChannelSharePercent}%)`
              : ""}
          </p>
        </div>
      </div>

      <p className="owner-dashboard__traffic-intro">
        Before someone looks at programs or clicks Register, this shows how they
        landed on your site — search, social, a shared link, and so on.
      </p>

      {takeaway && (
        <p className="owner-dashboard__traffic-takeaway">{takeaway}</p>
      )}

      <ul className="owner-dashboard__traffic-list">
        {channels.map((row) => (
          <li key={row.channel} className="owner-dashboard__traffic-row">
            <div className="owner-dashboard__traffic-row-head">
              <span className="owner-dashboard__traffic-channel">
                {row.friendlyLabel || row.channel}
              </span>
              <span className="owner-dashboard__traffic-stats">
                {formatVisitCount(row.sessions)} · {row.sharePercent}%
              </span>
            </div>
            <div className="owner-dashboard__traffic-bar-track" aria-hidden="true">
              <span
                className="owner-dashboard__traffic-bar-fill"
                style={{ width: `${Math.max(row.sharePercent, 4)}%` }}
              />
            </div>
            {(row.description || row.hint) && (
              <p className="owner-dashboard__traffic-hint">
                {row.description || row.hint}
              </p>
            )}
            {row.ownerTip && row.sharePercent >= 15 && (
              <p className="owner-dashboard__traffic-tip">
                <strong>What you can do:</strong> {row.ownerTip}
              </p>
            )}
          </li>
        ))}
      </ul>

      {visibleSources.length > 0 && (
        <div className="owner-dashboard__traffic-detail">
          <h4 className="owner-dashboard__traffic-detail-title">
            Specific places they came from
          </h4>
          <p className="owner-dashboard__traffic-detail-note">
            The exact site or search engine when we can tell — Google, Facebook,
            a partner website, and so on.
          </p>
          <ul className="owner-dashboard__traffic-detail-list">
            {visibleSources.map((row) => (
              <li key={`${row.source}-${row.medium}`}>
                <span>{row.friendlyLabel || row.label}</span>
                <strong>
                  {formatVisitCount(row.sessions)} ({row.sharePercent}%)
                </strong>
              </li>
            ))}
          </ul>
        </div>
      )}
    </article>
  );
};

export default TrafficSources;
